import React, {useState, useRef, useEffect} from 'react';
import styles from "./RedeemBottomInfo.module.css";

interface RedeemBottomInfoProps {
    info?: string;
}

const RedeemBottomInfo: React.FC<RedeemBottomInfoProps> = (props) => {
    const {info} = props;
    const onClickBack = () => {
    }
    return (
        <div className={styles.notice}>
            It may take 1 or 2 weeks to identify whether you are a robot,
            Cancellation is acceptable before successful payment and the
            redemption amount will be returned. But cannot be canceled
            while your withdrawal is processing. You cannot submit a new
            withdrawal request until your last withdrawal is solved.
        </div>
    );
};

export default RedeemBottomInfo;
